import { Children } from '@/utils/reactTypes';
import { Box, SxProps } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

export const AxlePageHeader = ({
    title,
    description = '',
    children = null,
    sx,
}: {
    title: string;
    description?: string;
    children?: Children;
    sx?: SxProps;
}) => (
    <Box mb={3} sx={sx}>
        <Box display={'flex'} flexWrap={'wrap'} justifyContent={'space-between'} gap={2}>
            <Box display={'flex'} alignItems={'center'} minWidth={0}>
                <Tooltip title={description} placement='right-end'>
                    <Typography variant='h1'>{title}</Typography>
                </Tooltip>
            </Box>
            {/* Full width below `sm` so the actions drop under the title. From `sm` up they sit
                beside the title when both fit, otherwise they wrap onto their own line, stay
                right-aligned, and then wrap among themselves instead of overflowing the page. */}
            {children ? (
                <Box
                    display={'flex'}
                    gap={2}
                    alignItems={'center'}
                    flexWrap={'wrap'}
                    minWidth={0}
                    width={{ xs: '100%', sm: 'auto' }}
                    ml={{ sm: 'auto' }}
                >
                    {children}
                </Box>
            ) : null}
        </Box>
    </Box>
);
